import { Injectable, inject } from '@angular/core';
import { AssignmentProcessService, RestartFailedAssignmentsResponse } from '@6grain/masofa-monolith-api-client/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Response of POST /assignments/restart-failed. */
export interface RestartFailedAssignmentsResult {
  processKey: string | null;
  requested: number;
  changed: number;
  skipped: number;
}

/** Batch restart of failed assignments and completed assignments explicitly marked as skipped. */
@Injectable({ providedIn: 'root' })
export class RestartFailedAssignmentsService {
  private readonly api = inject(AssignmentProcessService);

  restart(processKey?: string | null): Observable<RestartFailedAssignmentsResult> {
    const key = processKey?.trim();
    return this.api.assignmentsRestartFailedPost(key || undefined).pipe(map(normalizeRestart));
  }
}

function normalizeRestart(row: RestartFailedAssignmentsResponse): RestartFailedAssignmentsResult {
  return {
    processKey: row.processKey ?? null,
    requested: row.requested ?? 0,
    changed: row.changed ?? 0,
    skipped: row.skipped ?? 0,
  };
}
